module.exports = __webpack_public_path__ + "img/line.bce8474e.svg";